/**
 * Static channel registry, mirroring the backend at
 * `good-outcomes-api/app/models/golab_channels.py` and the prototype
 * `CHANNELS` map in `/Users/laurencesonnenberg/dataeq-code/go_lab/go_lab_standalone.html`.
 *
 * Channels are a fixed set — adding one is a deliberate platform-level
 * decision, not a per-taxonomy concern. Contrast with dimensions, which
 * are taxonomic data and live in `taxonomy_versions.taxonomy_data`
 * server-side. See "Dimensions are taxonomic data" in
 * `docs/features/go-lab/datasets-and-annotation/work-specs.md`.
 */

export type ChannelKey =
  | 'social-media'
  | 'reviews'
  | 'emails'
  | 'call-centre'
  | 'live-chat'
  | 'complaints';

export interface ChannelMeta {
  name: string;
  color: string;
  icon: string;
}

export const CHANNELS: Record<ChannelKey, ChannelMeta> = {
  'social-media': { name: 'Social Media', color: '#1DA1F2', icon: 'message-circle' },
  reviews: { name: 'Reviews', color: '#F59E0B', icon: 'star' },
  emails: { name: 'Emails', color: '#8B5CF6', icon: 'mail' },
  'call-centre': { name: 'Call Centre Transcripts', color: '#10B981', icon: 'phone' },
  'live-chat': { name: 'Live Chat', color: '#EC4899', icon: 'message-square' },
  complaints: { name: 'Formal Complaints', color: '#EF4444', icon: 'alert-circle' },
};
